<template lang="pug">
.main
  tab(:left-text='leftText', :right-text='rightText', v-if="(name === 'TodayHot' || name=== 'FutureChance') && !hideNavigate")
  router-view
</template>

<script>
import Tab from '@components/tab'

export default {
  components: {
    Tab
  },
  data() {
    return {
      leftText: '近期热点',
      rightText: '投资日历',
      name: ''
    }
  },
  computed: {
    hideNavigate() {
      return this.$store.state.hideNavigate
    }
  },
  mounted() {
    this.$router.onReady(() => {
      this.name = this.$route.name
      if (this.$route.query.hideNavigate) {
        this.$store.dispatch('hideNavigate', this.$route.query.hideNavigate)
      }
      this.$store.dispatch('colorType', this.$route.query.colorType || 'default')
      this.$store.dispatch('loadHideNavigate')
      this.$store.dispatch('loadColorType')
    })
  },
  watch: {
    $route(newVal) {
      this.name = newVal.name
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
